<app-toast [message]="toast.message"></app-toast>

<div class="row">

  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card border-0">
      <h4 class="card-header border-0">
        Statistics
      </h4>
      <div class="card-body" [ngClass]="{ 'disabled': isLoading.stats }">
        <h5>
          Filters
          <app-spinner [condition]="isLoading.stats"></app-spinner>
        </h5>
        <form class="bg-light border rounded-lg px-3 pt-2 pb-1 mb-4" (ngSubmit)="getStats()">
          <div class="row">
            <div class="form-group col-md-4">
              <label>Client</label>
              <select class="form-control" [ngClass]="{ 'is-touched': client }" name="client" [(ngModel)]="client" (change)="getStats()">
                <option value="" selected>Any client</option>
                @for (client of clients; track client) {
                  <option [value]="client._id">{{client.name}}</option>
                }
              </select>
            </div>
            <div class="form-group col-md-4">
              <label>Start date</label>
              <a class="float-end small" [routerLink]="" [hidden]="startDate === ''" (click)="startDate = ''; getStats()">reset</a>
              <input type="date" class="form-control" [ngClass]="{ 'is-touched': startDate }"
                name="startDate" [(ngModel)]="startDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" (change)="getStats()">
            </div>
            <div class="form-group col-md-4">
              <label>End date</label>
              <a class="float-end small" [routerLink]="" [hidden]="endDate=== ''" (click)="endDate = ''; getStats()">reset</a>
              <input type="date" class="form-control" [ngClass]="{ 'is-touched': endDate }"
                name="endDate" [(ngModel)]="endDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" (change)="getStats()">
            </div>
          </div>
          <div class="row">
            <!-- <div class="form-group col-md-6">
            <label>Team member</label>
            <select class="form-control" [ngClass]="{ 'is-touched': user }" name="user" [(ngModel)]="user" (change)="getStats('user')">
              <option value="" selected>Any team member</option>
              <option *ngFor="let member of team" [value]="member._id">{{member.lastName}} {{member.firstName}}</option>
            </select>
          </div> -->
        </div>
      </form>
      <div class="row">
        <div class="col-lg-8 mb-3">
          <div class="card">
            <h5 class="card-header border-0">
              Activities per month
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              @if (!counters.months?.length) {
                <div>
                  Nothing found.
                </div>
              }
              @for (counter of counters.months; track counter) {
                <div class="text-center">
                  <h4>{{counter.count}}</h4>
                  {{counter.month}}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Average
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              <div class="text-center">
                <h4>{{counters.avg | number:'1.0-1'}}</h4>
                average per month
              </div>
              <div class="text-center">
                <h4>{{counters.avg / 4 | number:'1.0-1'}}</h4>
                average per week
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per week <small class="text-muted">(3 months)</small>
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartWeek, 'activities_per_week')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByWeek', 'date,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart1"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per type
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartActivity, 'activity_per_type')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByActivity', 'type,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart2"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per team user
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartUser, 'activities_per_team_user')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByUser', 'name,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'user')" [disabled]="skip.user <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.user}} to {{skip.user + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'user')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart3"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per department
              <a class="small float-end" [routerLink]="" (click)="exportChart(donutChartDepartment, 'activities_per_department')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByDepartment', 'department,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="donut-chart1"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Studios activities per client
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartClientStudios, 'activities_per_client_studios')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByClientStudios', 'client,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'clientStudios')" [disabled]="skip.clientStudios <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.clientStudios}} to {{skip.clientStudios + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'clientStudios')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart6"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per topic
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartCluster, 'activities_per_topic')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByCluster', 'topic,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart5"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row" [hidden]="!canViewStats">
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per client
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartClient, 'activities_per_client')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByClient', 'client,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'client')" [disabled]="skip.client <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.client}} to {{skip.client + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'client')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart4"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Meeting / Relationship with institution activities per client
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartClientMeeting, 'activities_per_client_meeting')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByClientMeeting', 'client,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'clientMeeting')" [disabled]="skip.clientMeeting <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.clientMeeting}} to {{skip.clientMeeting + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'clientMeeting')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart7"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 mb-3">
          <div class="card">
            <h5 class="card-header border-0">
              Activities per month with stakeholders
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              @if (!countersStakeholders.months?.length) {
                <div>
                  Nothing found.
                </div>
              }
              @for (counter of countersStakeholders.months; track counter) {
                <div class="text-center">
                  <h4>{{counter.count}}</h4>
                  {{counter.month}}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Average
            </h5>
            <div class="card-body d-flex flex-row justify-content-around">
              <div class="text-center">
                <h4>{{countersStakeholders.avg | number:'1.0-1'}}</h4>
                average per month
              </div>
              <div class="text-center">
                <h4>{{countersStakeholders.avg / 4 | number:'1.0-1'}}</h4>
                average per week
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Stakeholders engaged per week <small class="text-muted">(3 months)</small>
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartWeekStakeholders, 'skakeholders_engaged_per_week')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByWeekStakeholders', 'date,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart8"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per party
              <i class="fa fa-info-circle small" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Activities per party of engaged stakeholders"></i>
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartParty, 'activities_per_party')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByParty', 'party,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart9"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per commission
              <i class="fa fa-info-circle small" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Activities per commission of engaged stakeholders"></i>
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartCommission, 'activities_per_commission')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByCommission', 'commission,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'commission')" [disabled]="skip.commission <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.commission}} to {{skip.commission + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'commission')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart10"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per stakeholder
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartStakeholder, 'activities_per_stakeholder')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByStakeholder', 'name,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'stakeholder')" [disabled]="skip.stakeholder <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.stakeholder}} to {{skip.stakeholder + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'stakeholder')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart11"></canvas>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <h5 class="card-header border-0">
              Activities per media company
              <i class="fa fa-info-circle small" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Activities per media company of engaged stakeholders"></i>
              <a class="small float-end" [routerLink]="" (click)="exportChart(barChartMedia, 'activities_per_media')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download chart">
                <i class="fa fa-download"></i>
              </a>
              <a class="small float-end me-3" [routerLink]="" (click)="downloadCSV('statsByMedia', 'media,activities')"
                data-bs-toggle="tooltip" data-position="top" data-delay="350" title="Download CSV">
                <i class="fa fa-database"></i>
              </a>
              <div class="btn-group me-3 float-end" role="group">
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('prev', 'media')" [disabled]="skip.media <= 0">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button class="btn btn-sm btn-outline-secondary cursor-default">
                  {{skip.media}} to {{skip.media + 10}}
                </button>
                <button class="btn btn-sm btn-outline-primary" (click)="getStatsByModelSkip('next', 'media')">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </h5>
            <div class="card-body">
              <canvas id="bar-chart12"></canvas>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-3">
          <div class="card h-100">
            <!-- <h5 class="card-header border-0"></h5> -->
            <!-- <div class="card-body"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
